import * as React from 'react'

function HamburgerIcon(props) {
  return (
    <svg
      className='hamburger-icon'
      width='34'
      height='23'
      viewBox='0 0 34 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <line
        x1='1.5'
        y1='1.5'
        x2='32.5'
        y2='1.5'
        stroke='black'
        strokeWidth='3'
        strokeLinecap='square'
      />
      <line
        x1='1.5'
        y1='11.5'
        x2='32.5'
        y2='11.5'
        stroke='black'
        strokeWidth='3'
        strokeLinecap='square'
      />
      <line
        x1='1.5'
        y1='21.5'
        x2='32.5'
        y2='21.5'
        stroke='black'
        strokeWidth='3'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default HamburgerIcon
